<template>
  <div
    class="main"
    v-loading.fullscreen.lock="loading"
    :element-loading-text="$t('loading')"
    element-loading-background="rgba(255, 255, 255, 0.8)"
  >
    <div class="main-content" v-if="!loading">
      <Content></Content>
      <RightNav></RightNav>
    </div>
  </div>
</template>

<script>
import Content from "../layout/content.vue";
import RightNav from "../layout/rightNav.vue";
import debounce from "lodash/debounce";
import Cookies from "js-cookie";
import { getAccessToken } from "@/utils/userInfo";

export default {
  provide() {
    return {
      // 刷新
      refresh() {
        this.$store.state.contentIsNeedRefresh = true;
        this.$nextTick(() => {
          this.$store.state.contentIsNeedRefresh = false;
        });
      },
    };
  },
  components: { Content, RightNav },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    haveToken() {
      let token = getAccessToken();
      let result = false;
      if (token && token !== "null" && token !== "undefind" && token !== "") {
        result = true;
      }
      return result;
    },
  },
  watch: {
    $route: "routeHandle",
  },
  created() {
    this.windowResizeHandle();
    // this.routeHandle(this.$route)
    if (this.haveToken) {
      Promise.all([
        this.getUserInfo(),
        // this.getPermissions()
      ]).finally(() => {
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  },
  methods: {
    // 点击其他地方隐藏领用车
    clickBody() {
      if (this.$refs.fixRight && this.$refs.fixRight.show) {
        this.$refs.fixRight.show = false;
      }
    },
    // 窗口改变大小
    windowResizeHandle() {
      this.$store.state.sidebarFold =
        document.documentElement["clientWidth"] <= 992 || false;
      window.addEventListener(
        "resize",
        debounce(() => {
          this.$store.state.sidebarFold =
            document.documentElement["clientWidth"] <= 992 || false;
        }, 150)
      );
    },
    // 路由, 监听
    routeHandle(route) {
      if (!route.meta.isTab) {
        return false;
      }
      var tab = this.$store.state.contentTabs.filter(
        (item) => item.name === route.name
      )[0];
      if (!tab) {
        tab = {
          ...window.SITE_CONFIG["contentTabDefault"],
          ...route.meta,
          name: route.name,
          params: { ...route.params },
          query: { ...route.query },
        };
        this.$store.state.contentTabs =
          this.$store.state.contentTabs.concat(tab);
      }
      this.$store.state.sidebarMenuActiveName = tab.menuId;
      this.$store.state.contentTabsActiveName = tab.name;
    },
    // 获取当前管理员信息
    getUserInfo() {
      return this.$http
        .get("/front/consumer/usercenter/custUserCenterInfo", {
          params: {
            appCode: "PLANTMATE_OFFICIAL",
            companyId: this.$store.state.user.defaultCompanyId + "" || "",
          },
        })
        .then(async ({ data: res }) => {
          if (res.code !== 0) {
            return false;
          }
          // this.$store.state.cardInfo = res.data.cardInfo
          this.$store.dispatch(
            "companyList",
            res.data.companyAccountInfo || []
          );
          this.$store.dispatch("setUserInfo", res.data.userInfo);
          Cookies.set("userId", res.data.userInfo.userId);
          Cookies.set("mobile", res.data.userInfo.mobile);
          // this.$store.state.user.username = res.data.userInfo.username
          // this.$store.state.user.name = res.data.userInfo.name
          // this.$store.state.user.mobile = res.data.userInfo.mobile
          // this.$store.state.user.email = res.data.userInfo.email
          // 获取生态服务用户数据
         await this.getEcologyUserInfo(res.data.userInfo.userId);
         await this.getCorpUser();
        })
        .catch(() => {});
    },
    // 获取权限
    getPermissions() {
      return this.$http
        .get("/sys/menu/permissions")
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          window.SITE_CONFIG["permissions"] = res.data;
        })
        .catch(() => {});
    },
    // 获取当前登录用户权限 及个人中心菜单
    getMenu() {
      this.$http
        .get(`/front/consumer/menu/bar/${window.SITE_CONFIG["appCode"]}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false;
          }
          window.SITE_CONFIG["menuList"] = res.data.tree;
          window.SITE_CONFIG["permissions"] = res.data.api;
          // window.SITE_CONFIG['permissions'] = res.data.permissions || []
        })
        .catch(() => {});
    },
    getEcologyUserInfo(userId) {
      return this.$http
        .get(`/front/oms/supplier/User/getSsoUserInfoByUserId/${userId}`)
        .then(({ data: res }) => {
          if (res.code == 0) {
            // 手动修改用户类型
            // res.data.userType = 2
            this.$store.commit("setEcologyUserInfo", res.data);
          }
        });
    },
    getCorpUser() {
      // 实际调用
      return this.$http
        .get("/front/sys/crop-site/customer-crop-site")
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$store.commit("setCorpUserInfo", res.data || {});
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  background: url("~@/assets/img/main/main_bg.png") no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
  .main-content {
    // display: flex;
    min-width: 1500px;
    position: relative;
  }
}
</style>
